<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>

                    <!-- Agregar  -->
                    <div class="row margen">
                        <div class="col-12">
                            <div class="panelBotonesFiltro mixto">
                                <button matTooltip="Agregar" class="btn boton botonXS" (click)="GuardarCopiaUltimo()" *ngIf="sistemaService.permisos.agregar">
                                    <span class="fa fa-plus"></span>
                                    <span> {{'Agregar'}}</span>
                                </button>
                                <div class="divisorH16 "></div>
                                <button matTooltip="Crear Copia" class="btn boton botonXS" (click)="GuardarCopia()"  *ngIf="sistemaService.permisos.agregar">
                                    <span class="fa fa-files-o"></span>
                                    <span> {{'Crear una Copia'}}</span>
                                </button>
                                <div class="divisorH16 "></div>
                            </div>
                        </div>
                    </div>

                    <div class="divisor16"></div>

                    <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [hoverStateEnabled]="true"
                        keyExpr="periodoevaluacionid"
                        [(selectedRowKeys)]="selectedRows"
                        [noDataText]="'Sin Datos'"
                        (onEditorPreparing)="onEditorPreparing($event)"
                        (onSelectionChanged)="ValidarGenerarCopia()"
                        [showColumnHeaders]="true"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>
                        <dxo-selection mode="single" [showCheckBoxesMode]="'always'"></dxo-selection>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <dxi-column
                            dataField="selected"
                            type="selection"
                            alignment="center">
                        </dxi-column>
                        <dxi-column
                            dataField="ciclo"
                            caption="Ciclo">
                        </dxi-column>
                        <dxi-column
                            dataField="descripcion"
                            caption="Nombre del periodo de evaluación">
                        </dxi-column>
                        <dxi-column
                            dataField="fechainicioperiodo"
                            caption="Inicio">
                        </dxi-column>
                        <dxi-column
                            dataField="fechainicioacuerdos"
                            caption="Inicio Acuerdos">
                        </dxi-column>
                        <dxi-column
                            dataField="fechafinacuerdos"
                            caption="Fin Acuerdos">
                        </dxi-column>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(2,cell.data.periodoevaluacionid)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Editar" class="tablaBoton separado edit" (click)="Formulario(3,cell.data.periodoevaluacionid)" *ngIf="sistemaService.permisos.editar">
                                <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                                <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>

<div #periodoevaluacionFormulario></div>

